'use strict'; // @ts-ignore libp2p crypto has no types

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var randomBytes = require('libp2p-crypto/src/random-bytes');

var _require = require('uint8arrays/to-string'),
    uint8ArrayToString = _require.toString;

var _require2 = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require2.fromString;

var PeerId = require('peer-id');

var _require3 = require('multiformats/hashes/sha2'),
    sha256 = _require3.sha256;
/**
 * @typedef {import('./message/rpc').RPC.IMessage} IMessage
 * @typedef {import('./message/rpc').RPC.Message} Message
 * @typedef {import('.').InMessage} NormalizedIMessage
 */

/**
 * Generatea random sequence number.
 *
 * @returns {Uint8Array}
 * @private
 */


var randomSeqno = function randomSeqno() {
  return randomBytes(8);
};
/**
 * Generate a message id, based on the `from` and `seqno`.
 *
 * @param {Uint8Array|string} from
 * @param {Uint8Array} seqno
 * @returns {Uint8Array}
 * @private
 */


var msgId = function msgId(from, seqno) {
  var fromBytes;

  if (from instanceof Uint8Array) {
    fromBytes = PeerId.createFromBytes(from).id;
  } else {
    fromBytes = PeerId.parse(from).id;
  }

  var msgId = new Uint8Array(fromBytes.length + seqno.length);
  msgId.set(fromBytes, 0);
  msgId.set(seqno, fromBytes.length);
  return msgId;
};
/**
 * Generate a message id, based on message `data`.
 *
 * @param {Uint8Array} data
 * @private
 */


var noSignMsgId = function noSignMsgId(data) {
  return sha256.encode(data);
};
/**
 * Check if any member of the first set is also a member
 * of the second set.
 *
 * @param {Set<number>|Array<number>} a
 * @param {Set<number>|Array<number>} b
 * @returns {boolean}
 * @private
 */


var anyMatch = function anyMatch(a, b) {
  var bHas;

  if (Array.isArray(b)) {
    /**
     * @param {number} val
     */
    bHas = function bHas(val) {
      return b.indexOf(val) > -1;
    };
  } else {
    /**
     * @param {number} val
     */
    bHas = function bHas(val) {
      return b.has(val);
    };
  }

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var val = _step.value;

      if (bHas(val)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};
/**
 * Make everything an array.
 *
 * @template T
 * @param {T|T[]} maybeArray
 * @returns {T[]}
 * @private
 */


var ensureArray = function ensureArray(maybeArray) {
  if (!Array.isArray(maybeArray)) {
    return [maybeArray];
  }

  return maybeArray;
};
/**
 * Ensures `message.from` is base58 encoded
 *
 * @template {{from?:any}} T
 * @param {T & IMessage} message
 * @param {string} [peerId]
 * @returns {NormalizedIMessage}
 */


var normalizeInRpcMessage = function normalizeInRpcMessage(message, peerId) {
  /** @type {NormalizedIMessage} */
  // @ts-ignore receivedFrom not yet defined
  var m = Object.assign({}, message);

  if (message.from instanceof Uint8Array) {
    m.from = uint8ArrayToString(message.from, 'base58btc');
  }

  if (peerId) {
    m.receivedFrom = peerId;
  }

  return m;
};
/**
 * @template {{from?:any, data?:any}} T
 *
 * @param {T & NormalizedIMessage} message
 * @returns {Message}
 */


var normalizeOutRpcMessage = function normalizeOutRpcMessage(message) {
  /** @type {Message} */
  // @ts-ignore from not yet defined
  var m = Object.assign({}, message);

  if (typeof message.from === 'string') {
    m.from = uint8ArrayFromString(message.from, 'base58btc');
  }

  if (typeof message.data === 'string') {
    m.data = uint8ArrayFromString(message.data);
  }

  return m;
};

module.exports = {
  randomSeqno: randomSeqno,
  msgId: msgId,
  noSignMsgId: noSignMsgId,
  anyMatch: anyMatch,
  ensureArray: ensureArray,
  normalizeInRpcMessage: normalizeInRpcMessage,
  normalizeOutRpcMessage: normalizeOutRpcMessage
};